import React, { Component, Fragment } from 'react';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import { connect } from 'react-redux';
// import { createStructuredSelector } from 'reselect';
import ReactEcharts from '../../Echarts/Echarts';
import { Tag } from 'antd';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
// import { getTranslationCache } from '../../../../../selectors/language';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
// import { getCurrentTimezone } from '../../../../../selectors/layout';
// import { makeSelectThemeing } from '../../../../../selectors/theme';
// import { defaultRefreshTime } from '../../constant.json';
import { objectOfObject } from '../../../Mock/MockJson';
import { config } from '../../constant';

class GuageRingWithCounter extends Component {
  constructor(props) {
    super(props);
    let option = this.getInitialState();
    this.state = {
      option: option.option,
      fromedit: props.graphprops.fromedit,
      translationCache: props.translationCache || [],
      refreshDateTime: moment(),
      errorInAPI: false,
      noDataInDB: false
    };
  }

  timeTicket = null;
  requestCheck = true;

  abortController = new window.AbortController();




  UNSAFE_componentWillReceiveProps() {
    let option = this.getInitialState();
    this.setState({
      option: option.option,
      fromedit: this.props.graphprops.fromedit === undefined ? true : true
    });
  }

  getOption = () => {
    let theme = this.props.selectedThemeing;
    let { graphprops } = this.props;
    return {
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: false,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#464646'
        }
      },
      toolbox: {
        showTitle: true,
        itemSize: 25,
        feature: {
          saveAsImage: {
            // backgroundColor: "black",
            title: 'download',
            backgroundColor: theme === 'lightTheme' ? 'white' : 'black',
            name: graphprops && graphprops.title ? graphprops.title : '',
            iconStyle: {
              color: 'none',
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
  };

  getInitialState = () => ({ option: this.getOption() });

  async componentDidMount() {
    if (this.timeTicket) {
      clearInterval(this.timeTicket);
    }
    let refreshTime = '';
    if (this.props.graphprops.refreshTime) {
      refreshTime = this.props.graphprops.refreshTime * 60000;
    } else {
      refreshTime = config.defaultRefreshTime;
    }
    this.getData(this.props, this.props.selectedThemeing);

    this.timeTicket = setInterval(() => {
      if (this.requestCheck) {
        this.getData(this.props, this.props.selectedThemeing);
      }
    }, refreshTime);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.graphprops !== this.props.graphprops ||
      prevProps.selectionDate !== this.props.selectionDate ||
      prevProps.selectionDateLive !== this.props.selectionDateLive ||
      prevProps.selectionMonth !== this.props.selectionMonth ||
      prevProps.selectionWeek !== this.props.selectionWeek ||
      prevProps.DeviceCode !== this.props.DeviceCode ||
      prevProps.shift !== this.props.shift ||
      prevProps.selectionDateRange !== this.props.selectionDateRange ||
      prevProps.dayMonthYear !== this.props.dayMonthYear ||
      prevProps.dropdownSelection !== this.props.dropdownSelection ||
      prevProps.dashboardPayload !== this.props.dashboardPayload ||
      prevProps.AssetCode !== this.props.AssetCode ||
      prevProps.translationCache !== this.props.translationCache
    ) {
      this.getData();
    }
  }
  getData = async () => {

    let {
      graphprops,
      selectionDate,
      selectionMonth,
      DeviceCode,
      selectionDateRange,
      dayMonthYear,
      currentTimeZone,
    } = this.props;
    let json = [];
    let series = [];
    let sampleJson = [];
    let { errorInAPI, noDataInDB } = this.state;
    this.requestCheck = false;
    errorInAPI = false;
    noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = objectOfObject;
      this.requestCheck = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: this.abortController,
            currentTimeZone,
          });
          this.requestCheck = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: this.abortController,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          this.requestCheck = true;
        }
      }
    }

    const queryArray = json.query;
    const query1Array = json.query1;

    json =
      queryArray &&
      Array.isArray(queryArray) &&
      queryArray.map((jsonData) => {
        // jsonData.tagvalue = (Math.random() * 100).toFixed(2) - 0;
        return {
          name: jsonData.Name,
          value: jsonData.Value
        };
      });
    let json1 =
      query1Array &&
      Array.isArray(query1Array) &&
      query1Array.map((jsonData) => {
        return {
          value: jsonData.Value
        };
      });

    const Target = [
      {
        value: 80,
        name: 'Target',
        title: {
          offsetCenter: ['-100%', '105%']
        },
        detail: {
          offsetCenter: ['-100%', '120%']
        }
      }
    ];
    const Total = [
      {
        value: json1 && json1[0].value,
        detail: {
          offsetCenter: ['0%', '0%']
        }
      }
    ];
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      sampleJson = [
        {
          title: {
            offsetCenter: ['-30%', '105%']
          },
          detail: {
            offsetCenter: ['-30%', '120%']
          }
        },
        {
          title: {
            offsetCenter: ['30%', '105%']
          },
          detail: {
            offsetCenter: ['30%', '120%']
          }
        },
        {
          title: {
            offsetCenter: ['100%', '105%']
          },
          detail: {
            offsetCenter: ['100%', '120%']
          }
        }
      ];
      let finalJson = [];
      json &&
        Array.isArray(json) &&
        json.length > 0 &&
        json.map((item, index) => {
          // let object = {}
          item.title = sampleJson && sampleJson[index] && sampleJson[index]['title'];
          item.detail = sampleJson && sampleJson[index] && sampleJson[index]['detail'];
          finalJson.push(item);
          return {};
        });
      const option = cloneDeep(this.state.option);
      if (json && Array.isArray(json) && json[0]) {
        series.push(
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 1,
                borderColor: '#464646'
              }
            },
            axisLine: {
              lineStyle: {
                width: 30
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: 50
            },
            //   aria:{
            //       decal:{
            //           enabled:true,
            //           show:true
            //       }
            //   }
            //  ,
            //    darkMode:true,
            data: finalJson,
            title: {
              fontSize: 12,
              color: 'white'
            },
            detail: {
              width: 38,
              height: 10,
              fontSize: 13,
              fontWeight: 'bold',
              color: 'auto',
              borderColor: 'auto',
              borderRadius: 5,
              borderWidth: 1,
              formatter: '{value}%'
            }
          },
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            data: Target,
            title: {
              fontSize: 12,
              color: 'white'
            },
            detail: {
              width: 38,
              height: 10,
              fontSize: 13,
              fontWeight: 'bold',
              color: 'auto',
              borderColor: 'auto',
              borderRadius: 5,
              borderWidth: 1,
              formatter: '{value}%'
            }
          },
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            data: Total,
            title: {
              fontSize: 12,
              color: 'white'
            },
            detail: {
              width: 38,
              height: 10,
              fontSize: 42,
              fontWeight: 'bold',
              color: 'auto',
              // borderColor: 'auto',
              // borderRadius: 5,
              // borderWidth: 1,
              formatter: '{value}%'
            }
          }
        );
      }

      option.series = series;
      if (option && option.series && option.series[0]) {
        option.series[0].pointer.show = false;
      }

      // option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0;
      // option.series[0].data[1].value = (Math.random() * 100).toFixed(2) - 0;
      // option.series[0].data[2].value = (Math.random() * 100).toFixed(2) - 0;

      this.setState({ option, refreshDateTime: moment() });
    }

    this.setState({
      errorInAPI,
      noDataInDB
    });
  };

  componentWillUnmount() {
    this.abortController.abort();
    clearInterval(this.timeTicket);
  }

  render() {
    const { refreshDateTime, errorInAPI, noDataInDB } = this.state;
    let { graphprops } = this.props;
    return (
      <Fragment>
        {graphprops && graphprops.checked === true ? (
          <Tag className="graphTag" color="blue">
            {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
          </Tag>
        ) : null}

        {noDataInDB === true || errorInAPI === true ? (
          noDataInDB === true ? (
            <NoRecordComponent />
          ) : (
            <ErrorComponent />
          )
        ) : (
          <ReactEcharts
            id={Math.ceil(Math.random(100, 100000) * 1000)}
            option={this.state.option}
            style={{
              height: '90%',
              width: '100%'
            }}
            className="react_for_echarts"
          />
        )}


      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(GuageRingWithCounter);
